var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.242,
    height: 77,
    viewBox: "0 0 40.242 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#9bb3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#9cb4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#cad5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#e7eaee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.208,
    y1: 0.5,
    x2: 2.605,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#9bb3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b1c3dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#cdd7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#e1e6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#edeff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.319,
    y1: 0.5,
    x2: 0.681,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.131,
    y1: 0.52,
    x2: 1.088,
    y2: 0.52,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff1511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6c7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.088,
    y1: 0.5,
    x2: 1.088,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0274e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#77e2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(-350.316 -261.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M404.8,360.815l1.443,11.667,1.411-12.4Z",
    transform: "translate(-18.633 -33.569)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M401.252,295.785l.982,39.672a4.215,4.215,0,0,0,1.355,2.993h0l2.688-.118.915-3.421a23.055,23.055,0,0,0,.638-8.553l-3.583-31.681Z",
    transform: "translate(-17.418 -11.204)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(350.316 296.328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 29.483,
    height: 3.472,
    transform: "translate(10.686 5.442) rotate(104.383)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(0.001 33.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M351.862,367.812l-1.175-.3-.37-2.94,3.362.862Z",
    transform: "translate(-350.317 -364.571)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M351.079,370.616l-.2-1.578,1.175.3Z",
    transform: "translate(-350.509 -366.099)",
    fill: "#373f42"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 1.409,
    height: 3.471,
    transform: "translate(11.036 4.077) rotate(104.384)",
    fill: "#373f42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    d: "M.983,0H3.319a0,0,0,0,1,0,0V3.471a0,0,0,0,1,0,0H.983A.983.983,0,0,1,0,2.488V.983A.983.983,0,0,1,.983,0Z",
    transform: "translate(11.861 0.862) rotate(104.382)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M402.251,276.216l2.776-10.917a2.694,2.694,0,0,0-2.14-3.344h0a2.694,2.694,0,0,0-3.128,2.253L398.2,275.573Z",
    transform: "translate(-16.376)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M358.146,331.846h0a1.9,1.9,0,0,0,2.255-1.28c4.794-15.366,9.668-31.992,14.049-36.872a4.009,4.009,0,0,1,3.483-1.282l7.2.893c4.24.684,6.606-8.29,2.593-10.023,0,0-8.661-7.053-17.205,7.954-4.181,6.458-7.107,14.495-9.33,22.946a.961.961,0,0,1-1.078.707l-3.9-.611a.959.959,0,0,0-1.063.659l-3.584,11.405a.959.959,0,0,0,.78,1.237l4.823.587-.394,1.269A1.9,1.9,0,0,0,358.146,331.846Z",
    transform: "translate(-0.411 -6.741)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(380.457 278.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M400.958,288.728a2.42,2.42,0,1,1-2.5-2.34A2.421,2.421,0,0,1,400.958,288.728Z",
    transform: "translate(-396.12 -286.387)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M400.344,289.435a1.14,1.14,0,1,1-1.177-1.1A1.14,1.14,0,0,1,400.344,289.435Z",
    transform: "translate(-396.785 -287.052)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    transform: "translate(359.5 313.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M368.63,342.812a2.179,2.179,0,1,1-2.249-2.108A2.178,2.178,0,0,1,368.63,342.812Z",
    transform: "translate(-364.272 -340.703)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M368.076,343.449a1.026,1.026,0,1,1-1.059-.993A1.026,1.026,0,0,1,368.076,343.449Z",
    transform: "translate(-364.871 -341.302)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsIcon3);
export default __webpack_public_path__ + "static/media/maths-icon-3.3c0a9e1015e236a74761f690702b7703.svg";
export { ForwardRef as ReactComponent };